var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "auto" } },
    [
      _c(
        "v-navigation-drawer",
        {
          attrs: {
            app: "",
            permanent: "",
            floating: "",
            clipped: "",
            width: _vm.navWidth,
            id: "nav_bar",
          },
          model: {
            value: _vm.drawer,
            callback: function ($$v) {
              _vm.drawer = $$v
            },
            expression: "drawer",
          },
        },
        [
          _c(
            "v-col",
            { staticClass: "ma-0 pa-2", attrs: { cols: "12" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0",
                  attrs: {
                    cols: "auto",
                    id: "nav_main_title",
                    align: "center",
                  },
                },
                [
                  _c("v-img", {
                    staticClass: "ma-0 pa-0",
                    attrs: {
                      height: "30px",
                      width: "8rem",
                      contain: "",
                      src: require("@/assets/images/usen_camera_logo.png"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.onlyAdmin == false
            ? _c(
                "v-list",
                { staticClass: "mt-0 pa-0", attrs: { dense: "" } },
                [
                  _vm.role == "main" || _vm.role == "head"
                    ? [
                        _vm._l(_vm.navItems, function (item) {
                          return [
                            item.name == "labelCreate"
                              ? [
                                  _vm.authorities.GET_STORE_LABEL
                                    ? _c(
                                        "v-row",
                                        {
                                          key: item.name,
                                          staticClass: "ma-0 pa-0",
                                          class: {
                                            nav_margin_top: _vm.exMargin,
                                          },
                                          attrs: {
                                            align: "start",
                                            justify: "space-between",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "ma-0 pa-3 pt-2 pb-2 pr-1 detail_group",
                                              staticStyle: {
                                                "font-size": "0.8rem",
                                                color: "white",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { align: "center" },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass:
                                                      "ma-0 pa-0 mr-2",
                                                    attrs: {
                                                      "max-height": "1.25rem",
                                                      "max-width": "1.25rem",
                                                      src: require("@/assets/images/" +
                                                        item.icon +
                                                        ".png"),
                                                      contain: "",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      attrs: { cols: "auto" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.tn(item.name)
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "auto" },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "back_clean_btn ma-0 pa-2 pl-3 pr-3",
                                                  attrs: {
                                                    width: "35px",
                                                    height: "40px",
                                                    elevation: "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.newLabelDialogVisible = true
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: {
                                                      "max-height": "1.5rem",
                                                      "max-width": "1.25rem",
                                                      src: require("@/assets/images/plus_round.png"),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              : item.name == "storeGroup"
                              ? [
                                  _c(
                                    "v-row",
                                    {
                                      key: item.name,
                                      staticClass:
                                        "ma-0 pa-0 nav_margin_bottom",
                                      class: {
                                        nav_margin_top:
                                          _vm.exMargin &&
                                          !_vm.authorities.GET_STORE_LABEL,
                                      },
                                      attrs: {
                                        align: "start",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-group",
                                        {
                                          key: _vm.refreshKey,
                                          staticClass: "ma-0 pa-0 detail_group",
                                          attrs: {
                                            "no-action": "",
                                            "append-icon": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "v-list-item-content",
                                                      {
                                                        staticClass:
                                                          "menu_item ma-0 pa-3 pt-2 pb-2 pr-1",
                                                        attrs: {
                                                          align: "left",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "0.8rem",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  align:
                                                                    "center",
                                                                },
                                                              },
                                                              [
                                                                item.active
                                                                  ? _c(
                                                                      "v-img",
                                                                      {
                                                                        staticClass:
                                                                          "ma-0 pa-0 mr-1",
                                                                        attrs: {
                                                                          "max-height":
                                                                            "0.8rem",
                                                                          "max-width":
                                                                            "0.8rem",
                                                                          src: require("@/assets/images/icon_bottom_arrow.png"),
                                                                        },
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                                item.active ==
                                                                  false ||
                                                                item.active ==
                                                                  undefined
                                                                  ? _c(
                                                                      "v-img",
                                                                      {
                                                                        staticClass:
                                                                          "ma-0 pa-0 mr-1",
                                                                        staticStyle:
                                                                          {
                                                                            transform:
                                                                              "rotate(-0.5turn)",
                                                                          },
                                                                        attrs: {
                                                                          "max-height":
                                                                            "0.8rem",
                                                                          "max-width":
                                                                            "0.8rem",
                                                                          src: require("@/assets/images/icon_bottom_arrow.png"),
                                                                        },
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                                _c("v-img", {
                                                                  staticClass:
                                                                    "ma-0 pa-0 mr-2",
                                                                  attrs: {
                                                                    "max-height":
                                                                      "1.25rem",
                                                                    "max-width":
                                                                      "1.2rem",
                                                                    src: require("@/assets/images/" +
                                                                      item.icon +
                                                                      ".png"),
                                                                    contain: "",
                                                                  },
                                                                }),
                                                                _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "ma-0 pa-0",
                                                                    attrs: {
                                                                      cols: "auto",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.tn(
                                                                            item.name
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                          model: {
                                            value: item.active,
                                            callback: function ($$v) {
                                              _vm.$set(item, "active", $$v)
                                            },
                                            expression: "item.active",
                                          },
                                        },
                                        _vm._l(
                                          item.children,
                                          function (child, idx) {
                                            return _c(
                                              "v-list-item",
                                              {
                                                key: child.groupId,
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: { width: "250px" },
                                              },
                                              [
                                                child.labelId
                                                  ? [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "ma-0 pa-0",
                                                          attrs: {
                                                            align: "start",
                                                            justify:
                                                              "space-between",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-group",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0 detail_group",
                                                              attrs: {
                                                                "sub-group": "",
                                                                "no-action": "",
                                                                "append-icon":
                                                                  "",
                                                                "prepend-icon":
                                                                  "",
                                                              },
                                                              scopedSlots:
                                                                _vm._u(
                                                                  [
                                                                    {
                                                                      key: "activator",
                                                                      fn: function () {
                                                                        return [
                                                                          _c(
                                                                            "v-list-item-content",
                                                                            {
                                                                              staticClass:
                                                                                "menu_item ma-0 pa-3 pt-2 pb-2 pr-1",
                                                                              attrs:
                                                                                {
                                                                                  align:
                                                                                    "left",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-size":
                                                                                        "0.8rem",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "v-row",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ma-0 pa-0",
                                                                                      attrs:
                                                                                        {
                                                                                          align:
                                                                                            "center",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      child.active
                                                                                        ? _c(
                                                                                            "v-img",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ma-0 pa-0 mr-1",
                                                                                              attrs:
                                                                                                {
                                                                                                  "max-height":
                                                                                                    "0.8rem",
                                                                                                  "max-width":
                                                                                                    "0.8rem",
                                                                                                  src: require("@/assets/images/icon_bottom_arrow.png"),
                                                                                                },
                                                                                            }
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      child.active ==
                                                                                        false ||
                                                                                      child.active ==
                                                                                        undefined
                                                                                        ? _c(
                                                                                            "v-img",
                                                                                            {
                                                                                              staticClass:
                                                                                                "ma-0 pa-0 mr-1",
                                                                                              staticStyle:
                                                                                                {
                                                                                                  transform:
                                                                                                    "rotate(-0.5turn)",
                                                                                                },
                                                                                              attrs:
                                                                                                {
                                                                                                  "max-height":
                                                                                                    "0.8rem",
                                                                                                  "max-width":
                                                                                                    "0.8rem",
                                                                                                  src: require("@/assets/images/icon_bottom_arrow.png"),
                                                                                                },
                                                                                            }
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _c(
                                                                                        "v-img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ma-0 pa-0 mr-2",
                                                                                          attrs:
                                                                                            {
                                                                                              "max-height":
                                                                                                "1.25rem",
                                                                                              "max-width":
                                                                                                "1.2rem",
                                                                                              src: require("@/assets/images/" +
                                                                                                child.icon +
                                                                                                ".png"),
                                                                                              contain:
                                                                                                "",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "v-col",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ma-0 pa-0 ellipsis",
                                                                                          staticStyle:
                                                                                            {
                                                                                              "max-width":
                                                                                                "120px",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              cols: "auto",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            " " +
                                                                                              _vm._s(
                                                                                                child.name
                                                                                              ) +
                                                                                              " "
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      },
                                                                      proxy: true,
                                                                    },
                                                                  ],
                                                                  null,
                                                                  true
                                                                ),
                                                              model: {
                                                                value:
                                                                  child.active,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      child,
                                                                      "active",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "child.active",
                                                              },
                                                            },
                                                            _vm._l(
                                                              child.children,
                                                              function (group) {
                                                                return _c(
                                                                  "v-list-item",
                                                                  {
                                                                    key: group.groupId,
                                                                    staticClass:
                                                                      "ma-0 pa-0",
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "250px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      {
                                                                        staticClass:
                                                                          "menu_item ma-0 pa-3",
                                                                        class: {
                                                                          current_route:
                                                                            group.groupId ==
                                                                            _vm.currentGroupId,
                                                                        },
                                                                        attrs: {
                                                                          align:
                                                                            "left",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              return _vm.goPush(
                                                                                group.path
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "ma-0 pa-0 pl-10",
                                                                            staticStyle:
                                                                              {
                                                                                "max-width":
                                                                                  "200px",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-col",
                                                                              {
                                                                                staticClass:
                                                                                  "ma-0 pa-0 ellipsis",
                                                                                attrs:
                                                                                  {
                                                                                    cols: "auto",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      group.name
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                          _vm.authorities
                                                            .GET_STORE_LABEL
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 pa-0 pr-1",
                                                                  attrs: {
                                                                    cols: "auto",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-menu",
                                                                    {
                                                                      attrs: {
                                                                        "offset-y":
                                                                          "",
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "activator",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var on =
                                                                                  ref.on
                                                                                var attrs =
                                                                                  ref.attrs
                                                                                return [
                                                                                  _c(
                                                                                    "v-btn",
                                                                                    _vm._g(
                                                                                      _vm._b(
                                                                                        {
                                                                                          staticClass:
                                                                                            "pa-2 pl-3 pr-3",
                                                                                          attrs:
                                                                                            {
                                                                                              width:
                                                                                                "25px",
                                                                                              height:
                                                                                                "25px",
                                                                                              id: "gray_btn",
                                                                                              elevation:
                                                                                                "0",
                                                                                            },
                                                                                        },
                                                                                        "v-btn",
                                                                                        attrs,
                                                                                        false
                                                                                      ),
                                                                                      on
                                                                                    ),
                                                                                    [
                                                                                      _c(
                                                                                        "v-img",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ma-0 pa-0",
                                                                                          attrs:
                                                                                            {
                                                                                              "max-height":
                                                                                                "1.5rem",
                                                                                              "max-width":
                                                                                                "1.25rem",
                                                                                              src: require("@/assets/images/more_btn.png"),
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list",
                                                                        {
                                                                          staticClass:
                                                                            "ma-0 pa-0",
                                                                          attrs:
                                                                            {
                                                                              dense:
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item",
                                                                            {
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.changeLabelName(
                                                                                      child,
                                                                                      idx
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      align:
                                                                                        "center",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.tn(
                                                                                        "changeLabelName"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "v-divider",
                                                                            {
                                                                              staticClass:
                                                                                "ma-0 pa-0",
                                                                              attrs:
                                                                                {
                                                                                  id: "middle_divider",
                                                                                },
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "v-list-item",
                                                                            {
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.deleteLabel(
                                                                                      child,
                                                                                      idx
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      align:
                                                                                        "center",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      _vm.tn(
                                                                                        "deleteLabel"
                                                                                      )
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  : [
                                                      _c(
                                                        "v-list-item-content",
                                                        {
                                                          staticClass:
                                                            "menu_item ma-0 pa-3",
                                                          class: {
                                                            current_route:
                                                              child.groupId ==
                                                              _vm.currentGroupId,
                                                          },
                                                          attrs: {
                                                            align: "left",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.goPush(
                                                                child.path
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0 pl-7",
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "ma-0 pa-0 ellipsis",
                                                                  attrs: {
                                                                    cols: "auto",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        child.name
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                              ],
                                              2
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                      _vm.authorities.ADD_STORE_GROUP
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "ma-0 pa-0",
                                              attrs: { cols: "auto" },
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "back_clean_btn ma-0 pa-2 pl-3 pr-3",
                                                  attrs: {
                                                    width: "35px",
                                                    height: "40px",
                                                    elevation: "0",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goPush(
                                                        item.path
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass: "ma-0 pa-0",
                                                    attrs: {
                                                      "max-height": "1.5rem",
                                                      "max-width": "1.25rem",
                                                      src: require("@/assets/images/plus_round.png"),
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              : item.name == "adminPage"
                              ? [
                                  _vm.admin
                                    ? _c(
                                        "v-list-item",
                                        {
                                          key: item.name,
                                          staticClass: "ma-0 pa-1 pt-0 pb-0",
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            {
                                              staticClass:
                                                "menu_item ma-0 pa-3 pt-2 pb-2 pr-1",
                                              class: {
                                                current_route:
                                                  _vm.currentRoute == item.name,
                                              },
                                              attrs: { align: "left" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goPush(item.path)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticStyle: {
                                                    "font-size": "0.8rem",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      attrs: {
                                                        align: "center",
                                                      },
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        staticClass:
                                                          "ma-0 pa-0 mr-2",
                                                        attrs: {
                                                          "max-height":
                                                            "1.25rem",
                                                          "max-width":
                                                            "1.25rem",
                                                          src: require("@/assets/images/" +
                                                            item.icon +
                                                            ".png"),
                                                          contain: "",
                                                        },
                                                      }),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "ma-0 pa-0",
                                                          attrs: {
                                                            cols: "auto",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.tn(
                                                                  item.name
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              : [
                                  _c(
                                    "v-list-item",
                                    {
                                      key: item.name,
                                      staticClass: "ma-0 pa-1 pt-0 pb-0",
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        {
                                          staticClass:
                                            "menu_item ma-0 pa-3 pt-2 pb-2 pr-1",
                                          class: {
                                            current_route:
                                              _vm.currentRoute == item.name,
                                          },
                                          attrs: { align: "left" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goPush(item.path)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticStyle: {
                                                "font-size": "0.8rem",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { align: "center" },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass:
                                                      "ma-0 pa-0 mr-2",
                                                    attrs: {
                                                      "max-height": "1.25rem",
                                                      "max-width": "1.25rem",
                                                      src: require("@/assets/images/" +
                                                        item.icon +
                                                        ".png"),
                                                      contain: "",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      attrs: { cols: "auto" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.tn(item.name)
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ]
                        }),
                      ]
                    : [
                        _vm._l(_vm.privateUserNavItems, function (item, index) {
                          return [
                            item.name == "adminPage"
                              ? [
                                  _vm.admin
                                    ? _c(
                                        "v-list-item",
                                        {
                                          key: item.name,
                                          staticClass: "ma-0 pa-1 pt-0 pb-0",
                                        },
                                        [
                                          _c(
                                            "v-list-item-content",
                                            {
                                              staticClass:
                                                "menu_item ma-0 pa-3 pt-2 pb-2 pr-1",
                                              class: {
                                                current_route:
                                                  _vm.currentRoute == item.name,
                                                nav_margin_top: index == 2,
                                              },
                                              attrs: { align: "left" },
                                              on: { click: _vm.goTestPage },
                                            },
                                            [
                                              _c(
                                                "v-list-item-title",
                                                {
                                                  staticStyle: {
                                                    "font-size": "0.8rem",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      attrs: {
                                                        align: "center",
                                                      },
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        staticClass:
                                                          "ma-0 pa-0 mr-2",
                                                        attrs: {
                                                          "max-height":
                                                            "1.25rem",
                                                          "max-width":
                                                            "1.25rem",
                                                          src: require("@/assets/images/" +
                                                            item.icon +
                                                            ".png"),
                                                        },
                                                      }),
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "ma-0 pa-0",
                                                          attrs: {
                                                            cols: "auto",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.tn(
                                                                  item.name
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              : [
                                  _c(
                                    "v-list-item",
                                    {
                                      key: item.name,
                                      staticClass: "ma-0 pa-1 pt-0 pb-0",
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        {
                                          staticClass:
                                            "menu_item ma-0 pa-3 pt-2 pb-2 pr-1",
                                          class: {
                                            current_route:
                                              _vm.currentRoute == item.name,
                                            nav_margin_top:
                                              item.name ==
                                              "privateNotification",
                                          },
                                          attrs: { align: "left" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goPush(item.path)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-title",
                                            {
                                              staticStyle: {
                                                "font-size": "0.8rem",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-row",
                                                {
                                                  staticClass: "ma-0 pa-0",
                                                  attrs: { align: "center" },
                                                },
                                                [
                                                  _c("v-img", {
                                                    staticClass:
                                                      "ma-0 pa-0 mr-2",
                                                    attrs: {
                                                      "max-height": "1.25rem",
                                                      "max-width": "1.25rem",
                                                      src: require("@/assets/images/" +
                                                        item.icon +
                                                        ".png"),
                                                    },
                                                  }),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      attrs: { cols: "auto" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.tn(item.name)
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                          ]
                        }),
                      ],
                ],
                2
              )
            : _c(
                "v-list",
                { staticClass: "mt-0 pa-0", attrs: { dense: "" } },
                [
                  _c(
                    "v-list-item",
                    { staticClass: "ma-0 pa-1 pt-0 pb-0" },
                    [
                      _c(
                        "v-list-item-content",
                        {
                          staticClass: "menu_item ma-0 pa-3 pt-2 pb-2 pr-1",
                          class: {
                            current_route: _vm.currentRoute == "adminPage",
                          },
                          attrs: { align: "left" },
                          on: {
                            click: function ($event) {
                              return _vm.goPush("/admin")
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-title",
                            { staticStyle: { "font-size": "0.8rem" } },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center" },
                                },
                                [
                                  _c("v-img", {
                                    staticClass: "ma-0 pa-0 mr-2",
                                    attrs: {
                                      "max-height": "1.25rem",
                                      "max-width": "1.25rem",
                                      src: require("@/assets/images/icon_user.png"),
                                    },
                                  }),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { cols: "auto" },
                                    },
                                    [_vm._v(" " + _vm._s("관리자메뉴") + " ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0 mt-5",
              attrs: { cols: "12", align: "left" },
            },
            [
              _c("v-divider", {
                staticClass: "ma-0 pa-0",
                attrs: { id: "middle_divider" },
              }),
              _vm.onlyAdmin == false
                ? _c(
                    "v-col",
                    { staticClass: "ma-0 pa-2 pb-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "back_clean_btn ma-0 pa-2",
                          attrs: {
                            width: "auto",
                            height: "auto",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.serviceDrawer = !_vm.serviceDrawer
                            },
                          },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: { color: "white" },
                              attrs: { align: "center" },
                            },
                            [
                              _c("v-img", {
                                staticClass: "ma-0 pa-0 mr-2",
                                attrs: {
                                  "max-height": "1.25rem",
                                  "max-width": "1.25rem",
                                  src: require("@/assets/images/service_menu_white.png"),
                                },
                              }),
                              _vm._v(" " + _vm._s(_vm.t("service")) + " "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-2",
                  class: { "pb-16": _vm.$store.state.isMobile },
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "offset-y": "",
                        attach: "",
                        bottom: "",
                        absolute: "",
                        "min-width": "230",
                        "position-x": 8,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "back_clean_btn ma-0 pa-0 pl-1 pr-1",
                                      attrs: {
                                        width: "235",
                                        height: "2.5rem",
                                        elevation: "0",
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { align: "end" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass:
                                            "ma-0 pa-0 pl-1 text-wrap",
                                          staticStyle: { width: "225px" },
                                          attrs: {
                                            cols: "auto",
                                            align: "left",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.td("welcome") +
                                                  " " +
                                                  _vm.userNickName
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("v-img", {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          "max-height": "1rem",
                                          "max-width": "1rem",
                                          src: require("@/assets/images/corner_bottom_arrow.png"),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "v-list",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: { border: "1px solid white" },
                        },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: {
                                cursor: "pointer",
                                background: "white",
                              },
                              on: { click: _vm.logout },
                            },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass: "ma-0 pa-0 pl-3 pr-3",
                                  attrs: { id: "list_font", align: "start" },
                                },
                                [_vm._v(" " + _vm._s(_vm.td("logout")) + " ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.admin
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2 pt-0",
                      staticStyle: { width: "10rem" },
                      attrs: { cols: "auto" },
                    },
                    [
                      _c("v-select", {
                        staticClass: "ma-0 pa-1",
                        attrs: {
                          items: _vm.langList,
                          dense: "",
                          "hide-details": "",
                          outlined: "",
                          label: "Language",
                          dark: "",
                          "item-text": "label",
                          "item-value": "value",
                        },
                        model: {
                          value: _vm.selectedLang,
                          callback: function ($$v) {
                            _vm.selectedLang = $$v
                          },
                          expression: "selectedLang",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.role == "private" || _vm.role == "branch"
                ? _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2 mt-5 pb-8",
                      attrs: { id: "private_nav_menu", cols: "12" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0 pl-1 pr-1 pt-15",
                              attrs: { id: "info_text_small" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-1",
                                  attrs: { cols: "auto", id: "info_text_left" },
                                },
                                [_vm._v(" " + _vm._s("住所") + ": ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-1",
                                  attrs: {
                                    cols: "auto",
                                    id: "info_text_right",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.userDetailData.unisCustomerAddress1
                                      ) +
                                      " "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.userDetailData.unisCustomerAddress2
                                      ) +
                                      " "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.userDetailData.unisCustomerAddress3
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0 pl-1 pr-1",
                              attrs: { id: "info_text_small" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-1",
                                  attrs: { cols: "auto", id: "info_text_left" },
                                },
                                [_vm._v(" " + _vm._s("電話") + ": ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-1",
                                  attrs: {
                                    cols: "auto",
                                    id: "info_text_right",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.userDetailData.phoneNo) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0 pl-1 pr-1",
                              attrs: { id: "info_text_small" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-1",
                                  attrs: { cols: "auto", id: "info_text_left" },
                                },
                                [_vm._v(" " + _vm._s("管理者") + ": ")]
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-1",
                                  attrs: {
                                    cols: "auto",
                                    id: "info_text_right",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.userNickNameLong) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-navigation-drawer",
        {
          staticStyle: { "z-index": "12" },
          attrs: {
            left: "",
            app: "",
            temporary: "",
            dark: "",
            width: this.$i18n.locale == "en" ? 310 : 275,
            color: "#313131",
          },
          model: {
            value: _vm.serviceDrawer,
            callback: function ($$v) {
              _vm.serviceDrawer = $$v
            },
            expression: "serviceDrawer",
          },
        },
        [
          _c(
            "v-list",
            { staticClass: "ma-0 pa-0", attrs: { id: "nav_font" } },
            [
              _c(
                "v-list-item",
                {
                  staticStyle: { cursor: "default" },
                  attrs: { align: "start" },
                },
                [
                  _c(
                    "v-list-item-title",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center", justify: "end" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "back_clean_btn ma-0 pa-0",
                              attrs: {
                                width: "auto",
                                height: "auto",
                                elevation: "0",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.serviceDrawer = false
                                },
                              },
                            },
                            [
                              _c("v-img", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  "max-height": "2rem",
                                  "max-width": "2rem",
                                  src: require("@/assets/images/close_square.png"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-list-item",
                {
                  staticStyle: { cursor: "default" },
                  attrs: { align: "start" },
                },
                [
                  _c(
                    "v-list-item-title",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { cols: "auto" },
                            },
                            [_c("strong", [_vm._v("USEN")])]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-0 pa-0",
                              staticStyle: { "font-size": "0.8rem" },
                              attrs: { cols: "auto" },
                            },
                            [_c("strong", [_vm._v(_vm._s(_vm.t("service")))])]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._l(_vm.userSubscribedService, function (item, index) {
                return _c(
                  "v-list-item",
                  {
                    key: index,
                    attrs: { align: "start", href: item.serviceLinkUrl },
                  },
                  [
                    _c(
                      "v-list-item-title",
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pb-2 pt-2 pl-2",
                            attrs: { id: "bottom_border", align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 mr-2",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("v-img", {
                                  staticClass: "ma-0 pa-0 mr-2",
                                  attrs: {
                                    "max-height": "2rem",
                                    "max-width": "2rem",
                                    src: item.serviceLogoUrl,
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 pb-1",
                                    attrs: { id: "nav_title", cols: "auto" },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        height: "0.8rem",
                                        "object-fit": "contain",
                                      },
                                      attrs: {
                                        src: item.serviceLogoTextUrl,
                                        height: "1rem",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    staticStyle: { "font-size": "0.8rem" },
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(item.serviceName)),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("NewLabelDialog", {
        attrs: { dialogVisible: _vm.newLabelDialogVisible },
        on: { visible: _vm.newLabelDialogVisibleFunc },
      }),
      _c("NameChangeDialog", {
        attrs: {
          dialogVisible: _vm.nameChangeDialogVisible,
          currentId: _vm.currentGroupLabelId,
          currentName: _vm.currentLabelName,
          editType: _vm.editNameType,
        },
        on: {
          nameUpdate: _vm.nameUpdateFunc,
          visible: _vm.nameChangeDialogVisibleFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }